// Footer.jsx
import React from "react";
import "./Footer.css";
import { FaEnvelope, FaMapMarkerAlt, FaPaperPlane } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";


const Footer = () => {

     const { language } = useLanguage();

  const t = translations[language];

  return (
    <footer className="footer" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="footer-top">
        <ul className="footer-links">
             <li><Link to="/about">{t.about}</Link></li>
            <li><Link to="/announcements">{t.announcements}</Link></li>
            <li><Link to="/vision">{t.vision}</Link></li>
            <li><Link to="/companies">{t.companies}</Link></li>
            <li><Link to="/board">{t.board}</Link></li>
            <li><Link to="/investments">{t.investments}</Link></li>
            <li><Link to="/contact">{t.contact}</Link></li>
            </ul>
        <img
          src="/imgs/Saudi_Vision_2030_logo.png"
          alt="Vision 2030"
          className="vision-logo"
        />
      </div>

      <hr />

      <div className="footer-main">
        <div className="footer-contact">
            <h4>{t.contactInfo}</h4>
          <div className="contact-item">
            <FaEnvelope className="icon" />
            <a href="mailto:info@falcomholding.com.sa">
              info@falcomholding.com.sa
            </a>
          </div>
          <div className="contact-item">
            <FaLinkedin className="icon linkedin" />
            <a
              href="https://www.linkedin.com/company/falcomholding-company/posts/?feedView=all"
              target="_blank"
              rel="noopener noreferrer"
            >
                {t.linkedIn}
            </a>
          </div>
          <div className="contact-item">
            <FaMapMarkerAlt className="icon" />
            <a
            href="https://maps.app.goo.gl/v4gd54UNaAY8XhvH8?g_st=ipc"
            target="_blank"
            rel="noopener noreferrer"
            >{t.address}
             </a>
             </div>

          <div className="contact-item">
            <FaPaperPlane className="icon" />
            <span>{t.poBox}</span>
          </div>
        </div>
      </div>

      <p className="footer-bottom">
        Copyright © FALCOM Holding 2025, CR License: 1010468790, VAT
        Registration Number: 302008831700003.
      </p>
    </footer>
  );
};

const translations = {
  en: {
    about: "About Us",
    announcements: "Announcements",
    vision: "Vision",
    companies: "Companies",
    board: "Board of Directors",
    investments: "Investments",
    contact: "Contact",
    contactInfo: "Contact Information:",
    address: "Yageen Building, Olaya Street with King Abdullah Street, Riyadh, KSA",
    poBox: "P.O. Box 884 Riyadh 11421, Kingdom of Saudi Arabia",
    linkedIn: "Falcom Holding Company",
  },
  ar: {
    about: "من نحن",
    announcements: "الإعلانات",
    vision: "الرؤية",
    companies: "الشركات",
    board: "مجلس الإدارة",
    investments: "الاستثمارات",
    contact: "تواصل معنا",
    contactInfo: "معلومات التواصل:",
    address: "مبنى يقين، شارع العليا مع شارع الملك عبدالله، الرياض، السعودية",
    poBox: "ص.ب 884 الرياض 11421، المملكة العربية السعودية",
    linkedIn: "شركة فالكم القابضة",
  },
};

export default Footer;
